import { styled } from 'styled-components'

import { Colors, Typography } from '@b-stock/fe-core/design-system'

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem;
  background-color: ${Colors.Semantic.Neutral.light_grey};
  border-radius: 0.5rem;
  gap: 0.5rem;
`

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0.25rem 0;
`

export const Label = styled.div`
  ${Typography.Body2}
  color: ${Colors.Semantic.Neutral.dark_grey};
`

export const Amount = styled.div`
  ${Typography.Body2Semibold}
`

export const Legend = styled.div`
  ${Typography.Body3}
  color: ${Colors.Semantic.Neutral.dark_grey};
`
